import vert from '../glsl/base.vert'
import frag from '../glsl/texture.frag'

//import RenderLayers from '../../config/RenderLayers'

const textureLoader = new THREE.TextureLoader()

AFRAME.registerComponent('tex', {
  dependencies: ['geometry'],
  schema: {
    src: {
      type: 'asset',
    },
  },
  init: function() {
    //this.scale = 0.7
    //this.verticalScale = 4.5

    //const mesh = this.el.getOrCreateObject3D('mesh')
    const mesh = this.el.getObject3D('mesh')

    this.mesh = mesh



    const textureWidth = this.el.components.geometry.data.width
    const textureHeight = this.el.components.geometry.data.height
    const textureRatio = textureWidth / textureHeight

    let bgSrc = this.data.src.getAttribute('src')
    let bg = textureLoader.load(bgSrc)
    bg.minFilter = THREE.LinearFilter

    this.material = new THREE.ShaderMaterial({
      transparent: true,

      uniforms: {
        texture: {
          type: 't',
          value: bg
        },
        viewResolution: {
          type: 'v2',
          value: [1, 1],
        },
        viewRatio: {
          type: 'f',
          value: 1,
        },
        textureRatio: {
          type: 'f',
          value: 1,
        },
        textureScale: {
          type: 'f',
          value: 1,
        },

      },
      vertexShader: vert,
      fragmentShader: frag,
    })

    // Object.defineProperty(this, 'darkAmount', {
    //   get: function() {
    //     return this.material.uniforms.darkAmount.value
    //   },
    //   set: function(val) {
    //     this.material.uniforms.darkAmount.value = val
    //   },
    // })

    this.material.depthTest = true
    //mesh.renderOrder = RenderLayers.WOOD_OVERLAY

    mesh.material = this.material

    //mesh.material.blending = THREE.MultiplyBlending

    this.viewportResize = this.viewportResize.bind(this) // update reference so can removed listener later - TODO: should this be handled differently?

    window.addEventListener('resize', this.viewportResize) //TODO: should this be handled differently?
    setTimeout(this.viewportResize, 0) // resize on next tick once dom has loaded // TODO: to trigger when canvas element is initialized instead
  },
  update: function(oldData) {
    // if (oldData.src !== this.data.src) {
    //   let src = this.data.src.getAttribute('src')
    //   this.material.uniforms.texture.value = textureLoader.load(src)
    //
    //   this.material.needsUpdate = true
    // }
    // if (this.data.darkSrc && oldData.darkSrc !== this.data.darkSrc) {
    //   let darkSrc = this.data.darkSrc.getAttribute('src')
    //   this.material.uniforms.darkTexture.value = textureLoader.load(darkSrc)
    //   this.material.needsUpdate = true
    // }
  },
  viewportResize: function() {
    const viewportCanvas = document.querySelector('.a-canvas')

    let viewWidth, viewHeight

    // const isUsingEffects  = this.el.sceneEl.systems.effects // && this.el.sceneEl.systems.effects.effects.length
    // const isUsingEffects = this.el.sceneEl.components['mask-spritesheet'] && this.el.sceneEl.components['mask-spritesheet'].attrValue.active !== 'false'
    // if (isUsingEffects) {
    //   const rendererSize = this.el.sceneEl.renderer.getSize()
    //
    //   viewWidth = rendererSize.width // viewportCanvas.attributes.width.value
    //   viewHeight = rendererSize.height // viewportCanvas.attributes.height.value
    // } else {
    //   viewWidth = viewportCanvas.attributes.width.value
    //   viewHeight = viewportCanvas.attributes.height.value
    // }

    viewWidth = viewportCanvas.attributes.width.value
    viewHeight = viewportCanvas.attributes.height.value
    console.log(999, viewWidth, viewHeight)
    //
    // const textureWidth = this.el.components.geometry.data.width
    // const textureHeight = this.el.components.geometry.data.height
    // const textureRatio = textureWidth / textureHeight
    //
    // const viewRatio = viewWidth / viewHeight // viewHeight / viewWidth //
    // console.log(888, textureWidth, textureHeight, textureRatio, viewRatio)
    // // scale to cover view
    // let textureScale = 1
    // if (viewRatio < textureRatio) {
    //   textureScale = viewRatio / textureRatio
    // }
    //
    // // let textureScale = textureRatio
    // if (viewRatio > textureRatio) {
    // textureScale = viewRatio
    // }

    this.material.uniforms.viewResolution.value = [viewWidth, viewHeight]
    //this.material.uniforms.viewRatio.value = 1 / viewRatio // viewHeight / viewWidth
    //this.material.uniforms.textureRatio.value = textureRatio // textureWidth / textureHeight
    //this.material.uniforms.textureScale.value = textureScale
    // this.material.uniforms.textureRatio.value = (viewWidth / viewHeight) / (textureWidth / textureHeight)

    //this.mesh.scale.y = 1
    //this.mesh.scale.x = 1

    // this.mesh.scale.x *= 0.75
    // this.mesh.scale.y *= 0.75
    // this.mesh.scale.x = this.mesh.scale.y = textureScale
  },

  remove: function() {
    window.removeEventListener('resize', this.viewportResize)
  },
  tick: function(time, timeDelta) {
    // if (this.targetCamera) {
    //   const cameraObject = this.targetCamera.object3D
    //
    //   if (!this.lastCameraPosition) {
    //     this.lastCameraPosition = {}
    //     this.lastCameraPosition.x = cameraObject.position.x
    //     this.lastCameraPosition.y = cameraObject.position.y
    //     this.lastCameraPosition.z = cameraObject.position.z
    //   }
    //
    //   this.cameraPositionDelta.x = cameraObject.position.x - this.lastCameraPosition.x
    //   this.cameraPositionDelta.y = cameraObject.position.y - this.lastCameraPosition.y
    //   this.cameraPositionDelta.z = cameraObject.position.z - this.lastCameraPosition.z
    //
    //   this.targetSlicePosition.x += this.cameraPositionDelta.x
    //   this.targetSlicePosition.y += this.cameraPositionDelta.y
    //   this.targetSlicePosition.z += this.cameraPositionDelta.z
    //
    //   this.slicePosition.x += (this.targetSlicePosition.x - this.slicePosition.x) * this.SLICE_POSITION_EASE
    //   this.slicePosition.y += (this.targetSlicePosition.y - this.slicePosition.y) * this.SLICE_POSITION_EASE
    //   this.slicePosition.z += (this.targetSlicePosition.z - this.slicePosition.z) * this.SLICE_POSITION_EASE
    //
    //   let scrollOffset = 0
    //   if (this.timelineScroll) {
    //     scrollOffset = this.timelineScroll.offset
    //   }
    //
    //   // this.material.uniforms.slicePosition.value.x = this.slicePosition.x
    //   // this.material.uniforms.slicePosition.value.y = this.slicePosition.y + scrollOffset * this.SLICE_SCROLL_VERTICAL_MOVE
    //   // this.material.uniforms.slicePosition.value.z = this.slicePosition.z + this.slicePosition.x * 2.0 + this.slicePosition.y * 2.0 + scrollOffset * this.SLICE_SCROLL_DEPTH_MOVE
    //
    //   this.lastCameraPosition.x = cameraObject.position.x
    //   this.lastCameraPosition.y = cameraObject.position.y
    //   this.lastCameraPosition.z = cameraObject.position.z
    // }
    // this.material.uniforms.time.value = time / 1000
  },

  tock: function(time, timeDelta) {},
  play: function() {},
  pause: function() {},
  updateSchema: function(data) {},
})
